module.exports = __webpack_public_path__ + "static/img/jiankang.c9409d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_new/jiankang.png
// module id = licO
// module chunks = 0